import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class MetaPropertyCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.MetaProperty;
    }
    visitNode(sb, expr, _options) {
        sb.context.reportUnsupported(expr);
    }
}

//# sourceMappingURL=MetaPropertyCompiler.js.map
